import './vscode/src/vs/workbench/contrib/welcomeViews/common/viewsWelcome.contribution.js';
import './vscode/src/vs/workbench/contrib/welcomeViews/common/newFile.contribution.js';

function getServiceOverride() {
    return {};
}

export { getServiceOverride as default };
